import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { CREATE_CART_PRESCRIPTION } from '../../../../server';
import { CartPrescription } from '@hiwaldo/sdk/interfaces';
import { cartSlice, StoreState } from '../../../redux';
import { modernVersionBridge } from '../../../utils';

type CreateCartPrescriptionEffectReturn = {
  createCartPrescription: (
    leftEyeProductVariantId: number | null,
    rightEyeProductVariantId: number | null,
    prescriptionId?: number
  ) => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

export const useCreateCartPrescriptionEffect = (
  callback?: () => void
): CreateCartPrescriptionEffectReturn => {
  const dispatch = useDispatch();
  const { cart, basketDataState } = useSelector((state: StoreState) => ({
    cart: state.orders.cart.cart,
    basketDataState: state.data.basket,
  }));

  const [doCreateCartPrescription, createCartPrescriptionState] = useMutation(
    CREATE_CART_PRESCRIPTION,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        dispatch(
          cartSlice.actions.updateCartPrescription(data.createCartPrescription)
        );
        modernVersionBridge.basket.updateCartPrescription(
          dispatch,
          basketDataState,
          data.createCartPrescription as CartPrescription
        );
        if (callback) {
          callback();
        }
      },
    }
  );

  const { loading, called, error } = createCartPrescriptionState;

  const createCartPrescription = (
    leftEyeProductVariantId: number | null,
    rightEyeProductVariantId: number | null,
    prescriptionId?: number
  ): void => {
    modernVersionBridge.basket.loading(dispatch, basketDataState, true);

    if (cart) {
      const data = {
        cartId: cart.id,
        leftEyeProductVariantId,
        rightEyeProductVariantId,
        prescriptionId: prescriptionId ? +prescriptionId : null,
      };
      doCreateCartPrescription({ variables: { data } }).then();
    }
  };

  const success = !loading && called && !error;

  return {
    createCartPrescription,
    loading,
    success,
    error: error?.message,
  };
};
